"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "patti": {
    "50f64f3c": [{
      "hkey": "19b15a11",
      "slug": "patti",
      "name": "Patti",
      "primary": true,
      "skipSearch": false
    }],
    "madoro": [{
      "hkey": "19b15a11",
      "slug": "patti",
      "name": "Patti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e84b1aa1": [{
      "hkey": "aacc22b4",
      "slug": "moreri-soprani",
      "name": "Moreri Soprani",
      "primary": true,
      "skipSearch": false
    }],
    "moreri": [{
      "hkey": "aacc22b4",
      "slug": "moreri-soprani",
      "name": "Moreri Soprani",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6d72d55a": [{
      "hkey": "19b15a11",
      "slug": "patti",
      "name": "Patti",
      "primary": true,
      "skipSearch": false
    }],
    "scarpiglia": [{
      "hkey": "19b15a11",
      "slug": "patti",
      "name": "Patti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;